import React, { useEffect, useRef, useState, } from "react";

import Select from 'react-select';
import GooglePlacesAutocomplete, { geocodeByAddress } from 'react-google-places-autocomplete';

import Resizer from 'react-image-file-resizer';

import axios from "axios";
import { apiUrl, serverUrl } from '../../components/Helpers/Config'
import { useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getPosts } from '../../redux/actions/journal';
import { addShowcasePost } from "../../redux/actions/showcase";

import { AiOutlineLeft, AiOutlineCloseCircle } from 'react-icons/ai'
import ModalShare from "../Journal/ModalShare";
import { IoMdCloseCircle } from 'react-icons/io'
import ButtonBlue from '../../components/Button/ButtonBlue';
import CommonLoader from '../../components/Button/Loader';
import DPEditor from "../../components/Editor/DPEditor";

import '../../styles/addpost.styles.scss'
import Swal from "sweetalert2";
import { staticFiles } from "../../components/Helpers/Static";
import ButtonSave from "../../components/Button/ButtonSave";
import { tokenAuthorize } from "../../components/Helpers/Common";
import ButtonCommon from "../../components/Button/ButtonCommon";
import { ActiveIconColor, Card } from "../Theme";
import { Progress } from "react-sweet-progress";
import "react-sweet-progress/lib/style.css";
import CROSS_BLACK_ICON from '@mui/icons-material/Clear';
import ActionButton from "../../components/Button/ActionButton";
import { ButtonCommonTopNew, DivBadge } from "../Theme";
import { BiLeftArrowAlt } from "react-icons/bi"
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
// accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, ,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.slideshow,application/vnd.openxmlformats-officedocument.presentationml.presentation"
const AnnounceEditor = (props) => {
    const id = props.match.params.id;
    const location = useLocation();

    const userProfile = useSelector(state => state.auth.user);


    const uploaderRef = useRef();
    const [contentEditor, setContentEditor] = useState();
    const handleEditorChange = (content, editor) => {
        setContentEditor(content);
    }

    const history = useHistory();
    const urlParams = useParams();
    const featImageRef = useRef();
    const [isLoading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const [post, setPost] = useState({
        title: '',
        sendEmail: false,
        attachments: [],
    })

    const [editAttachments, seteditAttachments] = useState([])

    const [files, setFiles] = useState([]);
    const [isCursor, setisCursor] = useState(false);
    //Attachments Limitations
    const [attachmentExtension, setAttachmentExtension] = useState(null);
    const [attachmentFileSize, setAttachmentFileSize] = useState(null);
    const [errorFileSizeLimits, setErrorFileSizeLimits] = useState([]);
    const [errorFileNotExtention, setErrorFileNotExtention] = useState([]);
    const modalRef = useRef();
    const [show, setShow] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const sourceRef = useRef(null);

    const goBack = () => {
        history.goBack();
    }

    const handleCheckChange = () => {
        setPost({
            ...post,
            sendEmail: !post.sendEmail
        })
    }

    useEffect(() => {
        if (id) {
            axios.get(`${apiUrl}${props.location.state?.id}/announcement/${id}`).then((res) => {
                setPost({
                    ...post,
                    title: res.data.announcement_title,
                    attachments: res.data.announcement_attachment?.length > 0 ? res.data.announcement_attachment : [],
                    sendEmail: res.data.announcement_email
                })
                seteditAttachments(res.data.announcement_attachment?.length > 0 ? res.data.announcement_attachment : [])
                setContentEditor(res.data.announcement_desc)
            }).catch(err => {
                tokenAuthorize(err?.response?.status);
            })
        }
    }, [id]);

    useEffect(() => {
        //Attachment Limitations
        axios.get(serverUrl.AttachmentsLimit).then(resp => {
            if (resp.status === 200) {
                setAttachmentExtension(resp?.data?.results?.attachment_types.length != 0 ? resp?.data?.results?.attachment_types.join(',') : null);
                setAttachmentFileSize(resp?.data?.results?.attachment_size ? resp?.data?.results?.attachment_size : null);
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
        })
    }, []);

    const addFiles = (e) => {
        let fileList = [], fileNames = [], errorFiles = [];
        setErrorFileSizeLimits([]);
        setErrorFileNotExtention([]);
        const allowedExtensions = (attachmentExtension || '').split(',').map(ext => ext.trim().toLowerCase()).filter(Boolean); // removes empty values
        const maxSizeMB = attachmentFileSize ?? Infinity;
        Array.from(e.currentTarget.files).forEach(file => {
            //file size convert to check MB format
            const sizeInMB = file.size / (1024 * 1024);
            const fileExt = '.' + file.name.split('.').pop().toLowerCase();

            const isSizeValid = sizeInMB <= maxSizeMB;
            const isExtValid = allowedExtensions.length === 0 || allowedExtensions.includes(fileExt);

            if (isSizeValid && isExtValid) {
                fileList.push(file)
                fileNames.push(file.name)
            }
            else {
                if (!isSizeValid) {
                    setErrorFileSizeLimits(prev => [...prev, file]);
                }
                else {
                    setErrorFileNotExtention(prev => [...prev, file]);
                }
                errorFiles.push(file)
            }
        });

        setFiles([...files, ...fileList])
        setPost({
            ...post,
            attachments: [...post.attachments, ...fileNames]
        });
        if (errorFiles.length > 0) {
            setShow(true)
        }
    }

    const removeFile = (id, name) => {
        setPost({
            ...post,
            attachments: [...post.attachments.filter((_, index) => index !== id)]
        })
        seteditAttachments([...editAttachments.filter((_, index) => index !== id)]);
        setFiles(prev =>
            prev.filter(file => file.name !== name)
        );
    }

    const submitPost = async (attachments = []) => {
        let dataAttachments = (editAttachments.length > 0 && attachments?.length > 0) ? editAttachments?.concat(attachments) : (attachments?.length > 0 && editAttachments?.length == 0) ? attachments : (editAttachments?.length > 0 && attachments?.length == 0) ? editAttachments : [];
        if (id) {
            let data = {
                "announcement_title": post.title,
                "announcement_desc": contentEditor ? contentEditor : "",
                "announcement_email": post.sendEmail,
                "announcement_attachment": dataAttachments,
                "modified_by": userProfile.user_id
            }
            axios.put(`${apiUrl}${props.location.state?.id}/announcement/${id}`, data).then((res) => {
                if (res.status == 200) {
                    goBack()
                }
                setisCursor(false)
            }).catch(err => {
                setisCursor(false)
                tokenAuthorize(err?.response?.status);
            })
        } else {
            let data = {
                "announcement_title": post.title,
                "announcement_desc": contentEditor ? contentEditor : "",
                "announcement_email": post.sendEmail,
                "announcement_attachment": attachments ? attachments : "",
                "created_by": userProfile.user_id
            }
            axios.post(`${apiUrl}${props.location.state}/announcement`, data).then((res) => {
                if (res.status == 200) {
                    goBack()
                }
                setisCursor(false)
            }).catch(err => {
                setisCursor(false)
                tokenAuthorize(err?.response?.status);
            })
        }
    }

    const validateForm = () => {
        if (post.title.length === 0) return { title: 'Missing title', text: 'Please enter a announcement title' }
        if (contentEditor == "" || contentEditor == undefined) return { title: 'Missing Description', text: 'Please enter a announcement description' }
        return null
    }

    const addEdit = (str) => {
        setisCursor(true)
        const validationResults = validateForm();

        if (validationResults !== null) {
            Swal.fire({
                heightAuto: false,
                title: validationResults.title,
                text: validationResults.text,
                icon: 'warning'
            })
            setisCursor(false)
            return;
        }
        if ((files.length > 0)) {
            const CancelToken = axios.CancelToken;
            const source = CancelToken.source();
            sourceRef.current = source;

            const attachmentFormData = new FormData();

            files.forEach(file => {
                attachmentFormData.append('file', file, file.name);
            })

            return axios.post(
                serverUrl.UploadMultipleFiles,
                attachmentFormData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                    cancelToken: source.token,
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(percentCompleted); // Use a state or variable to store progress
                    }
                }
            ).then(resp => {
                const attachments = resp.data.map(storedFile => (serverUrl.Base + storedFile.path));
                setUploadProgress(0);
                submitPost(attachments);
            }).catch(err => {
                if (axios.isCancel(err)) {
                    console.log('');
                } else {
                    console.error('');
                }
                setUploadProgress(0);
                setisCursor(false);
                return null;
            }).finally(() => {
                sourceRef.current = null;
            });
        }
        else {
            submitPost([]);
            setisCursor(false);
        }
    }

    const discardPost = () => {
        Swal.fire({
            heightAuto: false,
            title: "Changes not saved",
            text: "Are you sure to leave this page?",
            icon: "warning",
            showCancelButton: false,
            showDenyButton: true,
            confirmButtonText: "Confirm",
            denyButtonText: "Cancel",
            confirmButtonColor: "#3085d6",
            denyButtonColor: "#c1c1c1",
        }).then((result) => {
            if (result.isConfirmed) {
                goBack("", "")
            }
        });
    }

    const handleFileUpload = () => {
        uploaderRef.current.value = "";
        uploaderRef.current.click();
    }

    const handleCancelUpload = () => {
        sourceRef.current.cancel('Upload canceled by user');
        sourceRef.current = null;
        setUploadProgress(0);
    }

    const Popup = () => {
        const style = `${show ? "flex" : "hidden"} fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 z-50 justify-center items-center`;

        return (
            <div className={style} onClick={(e) => e.stopPropagation()}>
                <section className="">
                    <Card className="rounded-lg bg-white shadow-lg h-full max-h-screen overflow-hidden">
                        {/* Header */}
                        <div className="relative flex items-center justify-between px-5 py-3 border-b border-gray-200">
                            <div className="font-bold text-base">Error Files</div>
                            <CROSS_BLACK_ICON
                                className="w-6 h-6 cursor-pointer hover:opacity-60"
                                onClick={() => setShow(false)}
                            />
                        </div>

                        {/* Scrollable content area */}
                        <div className="overflow-y-auto px-3 py-4" ref={modalRef}>
                            <div className="space-y-2">
                                {errorFileNotExtention.length > 0 && (
                                    <div>
                                        <p className="text-sm px-2 text-justify">
                                            The following files are not supported:
                                        </p>
                                        <ul className="list-disc list-inside text-red-500 text-sm px-5">
                                            {errorFileNotExtention.map((file, index) => (
                                                <li key={`ext-${index}`} className="py-1">
                                                    {file.name}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                                {errorFileSizeLimits.length > 0 && (
                                    <div>
                                        <p className="text-sm px-2 text-justify">
                                            The following files exceed the size limit of {attachmentFileSize} MB:
                                        </p>
                                        <ul className="list-disc list-inside text-red-500 text-sm px-5">
                                            {errorFileSizeLimits.map((file, index) => (
                                                <li key={`size-${index}`} className="py-1">
                                                    {file.name}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>
                    </Card>
                </section>
            </div>
        );
    };

    if (isLoading) return (
        <div className='w-full flex justify-center'>
            <CommonLoader/>
        </div>
    )
    else return (
        <div className='p-6'>
            <Popup />


            <div className='flex flex-col md:flex-row md:gap-4 w-full'>

                <div className='md:w-3/4 flex flex-col' style={{ minHeight: '600px' }}>
                    <div className='w-full flex justify-between text-blue-500 font-semibold mb-4'>
{/* 
                        <ButtonCommonTopNew className={`rounded-lg px-5 py-2 flex items-center w-max cursor-pointer`} onClick={discardPost}>
                            <BiLeftArrowAlt className='w-5 h-5' />
                            <h1 className='text-xs lg:text-sm'>
                                Back
                            </h1>
                        </ButtonCommonTopNew> */}
                        <div
                            className={`rounded-lg p-0 flex gap-1 items-center w-max cursor-pointer`}
                            onClick={discardPost}
                        >
                            <KeyboardBackspaceIcon className="text-3xl primaryIcon" />
                            <h1 className="text-lg blueColor font-semibold">Back</h1>
                        </div>
                        <ActionButton className={"py-2 px-4 h-10"} buttonStyle="w-full" textStyle="" style="px-8 py-4" title="Send" width="full" noCursor={isCursor} disabled={isCursor} onClick={() => addEdit()} />
                    </div>
                    <input
                        className="bg-transparent w-full rounded-sm mb-2 mt-0 text-xl outline-none"
                        type="text" placeholder="Enter announcement title"
                        value={post.title}
                        onChange={(e) => {
                            setPost({
                                ...post,
                                title: e.target.value,
                            })
                        }
                        }
                    />
                    <DPEditor
                        content={contentEditor}
                        setContent={handleEditorChange}
                        height={500}
                    />
                </div>

                <div className="flex-1 flex flex-col pl-4 pr-0 add-sm md:add-md">
                    <div className="flex justify-center items-center greyColor border-transparent text-lg pb-1 w-max font-bold border-b-2 hover:no-underline hover:text-black cursor-pointer"><span><div className="flex items-center"><div className=" w-1.5 h-1.5 mr-3 rounded-full greyBackGroundColor"></div>Properties</div></span></div>
                    <div className="flex items-center gap-2 mt-12 mb-4">
                        <label>Send email ?</label>
                        <input type="checkbox" className='border-2 border-gray-400 focus:ring-0 form-checkbox h-4 rounded primaryIcon checkBoxCustom w-4' checked={post.sendEmail} onChange={handleCheckChange} />
                    </div>
                    <p className="mb-2">Attachments</p>
                    <div className="flex flex-col mb-3">
                        <div className="borderGray backGroundColor  p-4 rounded-2xl flex items-center">
                            <ButtonCommonTopNew
                                className=" rounded-lg px-3 py-2 cursor-pointer items-center justify-center filter pointer text-sm w-max"
                                onClick={() => handleFileUpload()}
                            >
                                Browse
                            </ButtonCommonTopNew>
                            <span className="text-sm ml-3 blueColor">Upload attachments</span>
                        </div>
                        <input
                            className="hidden"
                            ref={uploaderRef}
                            type="file"
                            accept={attachmentExtension}
                            multiple onChange={(e) => addFiles(e)}
                        />
                    </div>

                    {
                        post.attachments && post.attachments.length > 0 &&
                        <>
                            <div className="flex flex-wrap gap-2">

                                {
                                    post.attachments &&
                                    post.attachments.map((item, idx) => {
                                        let itemName = item
                                        if (itemName) {
                                            const lastSlash = item.lastIndexOf('/');
                                            if (lastSlash !== -1) {
                                                const fileName = item?.slice(item.lastIndexOf('/') + 1) || '';
                                                const finalName = fileName.includes('-') ? fileName.slice(fileName.indexOf('-') + 1) : fileName;
                                                itemName = finalName
                                            }
                                            return (
                                                <DivBadge key={idx} className="flex items-center rounded-lg px-3 justify-center w-max" >
                                                    <a
                                                        href={item}
                                                        target="_blank" rel="noopener noreferrer"
                                                        className="flex text-sm p-1 nav-navigate"
                                                    >
                                                        <div className=" text-white">{itemName}</div>
                                                    </a>
                                                    <div onClick={() => removeFile(idx, item)}>
                                                        <AiOutlineCloseCircle className="cursor-pointer text-white" />
                                                    </div>
                                                </DivBadge>
                                            )
                                        }
                                        return null;
                                    })
                                }
                            </div>
                        </>
                    }




                </div>
            </div>
            <div className={`${uploadProgress > 0 && uploadProgress < 100 ? "flex" : "hidden"} fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 block z-50`} onClick={(e) => e.stopPropagation()}>
                <section className="fixed transform -translate-y-2/4 -translate-x-2/4 top-2/4 left-2/4 w-full md:w-3/12">
                    <Card className="h-2/4 rounded-lg overflow-hidden" id="cards">
                        <div className="relative flex py-3">
                            <div className="w-full font-bold flex items-start px-5">
                                File Uploading In-progress
                            </div>
                        </div>
                        <hr className='text-gray-200' />
                        <div className="overflow-y-auto h-52 w-full scroll-smooth" ref={modalRef}>
                            <div className="w-full h-1/2 flex items-center justify-center">
                                <div className="w-1/2">
                                    <Progress percent={uploadProgress} status="active" />
                                </div>
                            </div>
                            <div className="w-full h-1/2 flex items-center justify-center">
                                <ActionButton className={"py-3 px-4 h-10"} buttonStyle="w-full" textStyle="" style="px-4 py-4" title="Cancel Uploads" width="full" onClick={() => handleCancelUpload()} />
                            </div>
                        </div>
                    </Card>
                </section>
            </div>
        </div>
    )
};

export default AnnounceEditor;

// import React, { useEffect, useRef, useState, } from "react";

// import Select from 'react-select';
// import GooglePlacesAutocomplete, { geocodeByAddress } from 'react-google-places-autocomplete';

// import Resizer from 'react-image-file-resizer';

// import axios from "axios";
// import { apiUrl, serverUrl } from '../../components/Helpers/Config'
// import { useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";

// import { getPosts } from '../../redux/actions/journal';
// import { addShowcasePost } from "../../redux/actions/showcase";

// import { AiOutlineLeft, AiOutlineCloseCircle } from 'react-icons/ai'
// import ModalShare from "../Journal/ModalShare";
// import { IoMdCloseCircle } from 'react-icons/io'
// import ButtonBlue from '../../components/Button/ButtonBlue';

// import DPEditor from "../../components/Editor/DPEditor";

// import '../../styles/addpost.styles.scss'
// import Swal from "sweetalert2";
// import { staticFiles } from "../../components/Helpers/Static";
// import ButtonSave from "../../components/Button/ButtonSave";
// import { tokenAuthorize } from "../../components/Helpers/Common";
// import ButtonCommon from "../../components/Button/ButtonCommon";
// import { ActiveIconColor, Card } from "../Theme";
// import { Progress } from "react-sweet-progress";
// import "react-sweet-progress/lib/style.css";
// import CROSS_BLACK_ICON from '@mui/icons-material/Clear';
// import ActionButton from "../../components/Button/ActionButton";
// // accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, ,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.slideshow,application/vnd.openxmlformats-officedocument.presentationml.presentation"
// const AnnounceEditor = (props) => {
//     const id = props.match.params.id;
//     const location = useLocation();

//     const userProfile = useSelector(state => state.auth.user);


//     const uploaderRef = useRef();
//     const [contentEditor, setContentEditor] = useState();
//     const handleEditorChange = (content, editor) => {
//         setContentEditor(content);
//     }

//     const history = useHistory();
//     const urlParams = useParams();
//     const featImageRef = useRef();
//     const [isLoading, setLoading] = useState(false);

//     const dispatch = useDispatch();

//     const [post, setPost] = useState({
//         title: '',
//         sendEmail: false,
//         attachments: [],
//     })

//     const [editAttachments, seteditAttachments] = useState([])

//     const [files, setFiles] = useState([]);
//     const [isCursor, setisCursor] = useState(false);
//     //Attachments Limitations
//     const [attachmentExtension, setAttachmentExtension] = useState(null);
//     const [attachmentFileSize, setAttachmentFileSize] = useState(null);
//     const [errorFileSizeLimits, setErrorFileSizeLimits] = useState([]);
//     const [errorFileNotExtention, setErrorFileNotExtention] = useState([]);
//     const modalRef = useRef();
//     const [show, setShow] = useState(false);
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const sourceRef = useRef(null);

//     const goBack = () => {
//         history.goBack();
//     }

//     const handleCheckChange = () => {
//         setPost({
//             ...post,
//             sendEmail: !post.sendEmail
//         })
//     }

//     useEffect(() => {
//         if (id) {
//             axios.get(`${apiUrl}${props.location.state?.id}/announcement/${id}`).then((res) => {
//                 setPost({
//                     ...post,
//                     title: res.data.announcement_title,
//                     attachments: res.data.announcement_attachment?.length > 0 ? res.data.announcement_attachment : [],
//                     sendEmail: res.data.announcement_email
//                 })
//                 seteditAttachments(res.data.announcement_attachment?.length > 0 ? res.data.announcement_attachment : [])
//                 setContentEditor(res.data.announcement_desc)
//             }).catch(err => {
//                 tokenAuthorize(err?.response?.status);
//             })
//         }
//     }, [id]);

//     useEffect(() => {
//         //Attachment Limitations
//         axios.get(serverUrl.AttachmentsLimit).then(resp => {
//             if (resp.status === 200) {
//                 setAttachmentExtension(resp?.data?.results?.attachment_types.length != 0 ? resp?.data?.results?.attachment_types.join(',') : null);
//                 setAttachmentFileSize(resp?.data?.results?.attachment_size ? resp?.data?.results?.attachment_size : null);
//             }
//         }).catch(err => {
//             tokenAuthorize(err?.response?.status);
//         })
//     }, []);

//     const addFiles = (e) => {
//         let fileList = [], fileNames = [], errorFiles = [];
//         setErrorFileSizeLimits([]);
//         setErrorFileNotExtention([]);
//         const allowedExtensions = (attachmentExtension || '').split(',').map(ext => ext.trim().toLowerCase()).filter(Boolean); // removes empty values
//         const maxSizeMB = attachmentFileSize ?? Infinity;
//         Array.from(e.currentTarget.files).forEach(file => {
//             //file size convert to check MB format
//             const sizeInMB = file.size / (1024 * 1024);
//             const fileExt = '.' + file.name.split('.').pop().toLowerCase();

//             const isSizeValid = sizeInMB <= maxSizeMB;
//             const isExtValid = allowedExtensions.length === 0 || allowedExtensions.includes(fileExt);

//             if (isSizeValid && isExtValid) {
//                 fileList.push(file)
//                 fileNames.push(file.name)
//             }
//             else {
//                 if (!isSizeValid) {
//                     setErrorFileSizeLimits(prev => [...prev, file]);
//                 }
//                 else {
//                     setErrorFileNotExtention(prev => [...prev, file]);
//                 }
//                 errorFiles.push(file)
//             }
//         });

//         setFiles([...files, ...fileList])
//         setPost({
//             ...post,
//             attachments: [...post.attachments, ...fileNames]
//         });
//         if (errorFiles.length > 0) {
//             setShow(true)
//         }
//     }

//     const removeFile = (id, name) => {
//         setPost({
//             ...post,
//             attachments: [...post.attachments.filter((_, index) => index !== id)]
//         })
//         seteditAttachments([...editAttachments.filter((_, index) => index !== id)]);
//         setFiles(prev =>
//             prev.filter(file => file.name !== name)
//         );
//     }

//     const submitPost = async (attachments = []) => {
//         let dataAttachments = (editAttachments.length > 0 && attachments?.length > 0) ? editAttachments?.concat(attachments) : (attachments?.length > 0 && editAttachments?.length == 0) ? attachments : (editAttachments?.length > 0 && attachments?.length == 0) ? editAttachments : [];
//         if (id) {
//             let data = {
//                 "announcement_title": post.title,
//                 "announcement_desc": contentEditor ? contentEditor : "",
//                 "announcement_email": post.sendEmail,
//                 "announcement_attachment": dataAttachments,
//                 "modified_by": userProfile.user_id
//             }
//             axios.put(`${apiUrl}${props.location.state?.id}/announcement/${id}`, data).then((res) => {
//                 if (res.status == 200) {
//                     goBack()
//                 }
//                 setisCursor(false)
//             }).catch(err => {
//                 setisCursor(false)
//                 tokenAuthorize(err?.response?.status);
//             })
//         } else {
//             let data = {
//                 "announcement_title": post.title,
//                 "announcement_desc": contentEditor ? contentEditor : "",
//                 "announcement_email": post.sendEmail,
//                 "announcement_attachment": attachments ? attachments : "",
//                 "created_by": userProfile.user_id
//             }
//             axios.post(`${apiUrl}${props.location.state}/announcement`, data).then((res) => {
//                 if (res.status == 200) {
//                     goBack()
//                 }
//                 setisCursor(false)
//             }).catch(err => {
//                 setisCursor(false)
//                 tokenAuthorize(err?.response?.status);
//             })
//         }
//     }

//     const validateForm = () => {
//         if (post.title.length === 0) return { title: 'Missing title', text: 'Please enter a announcement title' }
//         if (contentEditor == "" || contentEditor == undefined) return { title: 'Missing Description', text: 'Please enter a announcement description' }
//         return null
//     }

//     const addEdit = (str) => {
//         setisCursor(true)
//         const validationResults = validateForm();

//         if (validationResults !== null) {
//             Swal.fire({
//                 heightAuto: false,
//                 title: validationResults.title,
//                 text: validationResults.text,
//                 icon: 'warning'
//             })
//             setisCursor(false)
//             return;
//         }
//         if ((files.length > 0)) {
//             const CancelToken = axios.CancelToken;
//             const source = CancelToken.source();
//             sourceRef.current = source;

//             const attachmentFormData = new FormData();

//             files.forEach(file => {
//                 attachmentFormData.append('file', file, file.name);
//             })

//             return axios.post(
//                 serverUrl.UploadMultipleFiles,
//                 attachmentFormData,
//                 {
//                     headers: { 'Content-Type': 'multipart/form-data' },
//                     cancelToken: source.token,
//                     onUploadProgress: (progressEvent) => {
//                         const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                         setUploadProgress(percentCompleted); // Use a state or variable to store progress
//                     }
//                 }
//             ).then(resp => {
//                 const attachments = resp.data.map(storedFile => (serverUrl.Base + storedFile.path));
//                 setUploadProgress(0);
//                 submitPost(attachments);
//             }).catch(err => {
//                 if (axios.isCancel(err)) {
//                     console.log('');
//                 } else {
//                     console.error('');
//                 }
//                 setUploadProgress(0);
//                 setisCursor(false);
//                 return null;
//             }).finally(() => {
//                 sourceRef.current = null;
//             });
//         }
//         else {
//             submitPost([]);
//             setisCursor(false);
//         }
//     }

//     const discardPost = () => {
//         Swal.fire({
//             heightAuto: false,
//             title: "Changes not saved",
//             text: "Are you sure to leave this page?",
//             icon: "warning",
//             showCancelButton: false,
//             showDenyButton: true,
//             confirmButtonText: "Confirm",
//             denyButtonText: "Cancel",
//             confirmButtonColor: "#3085d6",
//             denyButtonColor: "#c1c1c1",
//         }).then((result) => {
//             if (result.isConfirmed) {
//                 goBack("", "")
//             }
//         });
//     }

//     const handleFileUpload = () => {
//         uploaderRef.current.value = "";
//         uploaderRef.current.click();
//     }

//     const handleCancelUpload = () => {
//         sourceRef.current.cancel('Upload canceled by user');
//         sourceRef.current = null;
//         setUploadProgress(0);
//     }

//     const Popup = () => {
//         const style = `${show ? "flex" : "hidden"} fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 z-50 justify-center items-center`;

//         return (
//             <div className={style} onClick={(e) => e.stopPropagation()}>
//                 <section className="">
//                     <Card className="rounded-lg bg-white shadow-lg h-full max-h-screen overflow-hidden">
//                         {/* Header */}
//                         <div className="relative flex items-center justify-between px-5 py-3 border-b border-gray-200">
//                             <div className="font-bold text-base">Error Files</div>
//                             <CROSS_BLACK_ICON
//                                 className="w-6 h-6 cursor-pointer hover:opacity-60"
//                                 onClick={() => setShow(false)}
//                             />
//                         </div>

//                         {/* Scrollable content area */}
//                         <div className="overflow-y-auto px-3 py-4" ref={modalRef}>
//                             <div className="space-y-2">
//                                 {errorFileNotExtention.length > 0 && (
//                                     <div>
//                                         <p className="text-sm px-2 text-justify">
//                                             The following files are not supported:
//                                         </p>
//                                         <ul className="list-disc list-inside text-red-500 text-sm px-5">
//                                             {errorFileNotExtention.map((file, index) => (
//                                                 <li key={`ext-${index}`} className="py-1">
//                                                     {file.name}
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     </div>
//                                 )}
//                                 {errorFileSizeLimits.length > 0 && (
//                                     <div>
//                                         <p className="text-sm px-2 text-justify">
//                                             The following files exceed the size limit of {attachmentFileSize} MB:
//                                         </p>
//                                         <ul className="list-disc list-inside text-red-500 text-sm px-5">
//                                             {errorFileSizeLimits.map((file, index) => (
//                                                 <li key={`size-${index}`} className="py-1">
//                                                     {file.name}
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     </Card>
//                 </section>
//             </div>
//         );
//     };

//     if (isLoading) return (
//         <div className='w-full flex justify-center'>
//             <img src={staticFiles.loading} alt='Loading...' className='w-10 h-10' />
//         </div>
//     )
//     else return (
//         <div className='my-10 px-20'>
//             <Popup />
//             <div className='w-full text-blue-500 font-semibold mb-4'>
//                 <ActiveIconColor className='flex items-center w-max cursor-pointer' onClick={discardPost}>
//                     <AiOutlineLeft className='w-10 h-10' />
//                     <h1 className='text-3xl'>
//                         Back
//                     </h1>
//                 </ActiveIconColor>
//             </div>

//             <div className='flex flex-col md:flex-row md:gap-2 w-full'>
//                 <div className='md:w-3/4 flex flex-col' style={{ minHeight: '600px' }}>
//                     <input
//                         className="bg-white p-3 w-full rounded-sm mb-2 text-3xl"
//                         type="text" placeholder="Enter announcement title"
//                         value={post.title}
//                         onChange={(e) => {
//                             setPost({
//                                 ...post,
//                                 title: e.target.value,
//                             })
//                         }
//                         }
//                     />
//                     <DPEditor
//                         content={contentEditor}
//                         setContent={handleEditorChange}
//                         height={500}
//                     />
//                 </div>
//                 <div className="flex-1 flex flex-col add-sm md:add-md">

//                     <div>
//                         <button
//                             className="border-gray-600 border bg-gray-200 flex flex-row rounded-lg px-3 py-2 items-center justify-center filter pointer"
//                             onClick={() => handleFileUpload()}
//                         >
//                             <p className="font-semibold whitespace-nowrap text-xs">Add attachments</p>
//                         </button>
//                         <input
//                             className="hidden"
//                             ref={uploaderRef}
//                             type="file"
//                             accept={attachmentExtension}
//                             onChange={(e) => addFiles(e)}
//                             multiple
//                         />

//                     </div>
//                     {
//                         post.attachments && post.attachments.length > 0 && Array.isArray(post.attachments) &&
//                         <div className="flex flex-col mt-2 overflow-scroll">
//                             <p className="">Attachments</p>
//                             {
//                                 post.attachments &&
//                                 post.attachments.map((item, idx) => {
//                                     let itemName = item

//                                     if (itemName) {
//                                         const lastSlash = item.lastIndexOf('/');

//                                         if (lastSlash !== -1) {
//                                             itemName = item.substr(lastSlash + 1, item.length - lastSlash - 1)
//                                         }
//                                         return (
//                                             <div key={idx} className="flex items-center" >
//                                                 <div onClick={() => removeFile(idx, itemName)}>
//                                                     <AiOutlineCloseCircle className="cursor-pointer" />
//                                                 </div>
//                                                 <a
//                                                     href={item}
//                                                     target="_blank" rel="noopener noreferrer"
//                                                     className="flex text-sm p-1 nav-navigate"
//                                                 >
//                                                     <ActiveIconColor className="hover:underline">{itemName}</ActiveIconColor>
//                                                 </a>
//                                             </div>
//                                         )
//                                     }
//                                     return null;
//                                 })
//                             }
//                         </div>
//                     }

//                     <div className="flex mt-4 mb-4 checkGreen">
//                         <label>Send email ?</label>
//                         <label class="container-check">
//                             <input type="checkbox" checked={post.sendEmail} onChange={handleCheckChange} />
//                             <span class="checkmark ml-3"></span>
//                         </label>
//                         {/* <input type="checkbox" checked={post.sendEmail} onChange={handleCheckChange} className="ml-3" /> */}
//                     </div>

//                     <div className="flex justify-around">
//                         <ButtonCommon className="px-10 py-3" buttonStyle={"w-full"} noCursor={isCursor} title="SEND" width="full" onClick={() => addEdit()} />
//                     </div>
//                 </div>
//             </div>
//             <div className={`${uploadProgress > 0 && uploadProgress < 100 ? "flex" : "hidden"} fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 block z-50`} onClick={(e) => e.stopPropagation()}>
//                 <section className="fixed transform -translate-y-2/4 -translate-x-2/4 top-2/4 left-2/4 w-full md:w-3/12">
//                     <Card className="h-2/4 rounded-lg overflow-hidden" id="cards">
//                         <div className="relative flex py-3">
//                             <div className="w-full font-bold flex items-start px-5">
//                                 File Uploading In-progress
//                             </div>
//                         </div>
//                         <hr className='text-gray-200' />
//                         <div className="overflow-y-auto h-52 w-full scroll-smooth" ref={modalRef}>
//                             <div className="w-full h-1/2 flex items-center justify-center">
//                                 <div className="w-1/2">
//                                     <Progress percent={uploadProgress} status="active" />
//                                 </div>
//                             </div>
//                             <div className="w-full h-1/2 flex items-center justify-center">
//                                 <ActionButton className={"py-3 px-4 h-10"} buttonStyle="w-full" textStyle="" style="px-4 py-4" title="Cancel Uploads" width="full" onClick={() => handleCancelUpload()} />
//                             </div>
//                         </div>
//                     </Card>
//                 </section>
//             </div>
//         </div>
//     )
// };

// export default AnnounceEditor;
